import React from "react";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { isEmpty } from "lodash";

import PrefTiles from "../Global/TablePreferenceColumns/PrefTiles";
import { getScreenPreferences } from "../../shared-utility/store/state/screenPreferences";
import { fetchDealsStatus } from "../../store/state/deal";
import { default as PipelineDealTileRows } from "../Global/TablePreferenceColumns/DealTableColumns/PipelineDealTileRows";
import GetDealTileRows from "../Global/TablePreferenceColumns/GetDealTileRows";
import dealStatuses from "../../constants/status";

class PipelineAndDeadTiles extends React.Component {
  render() {
    const { screenPreferenceList, location } = this.props;
    const { dealsByStatus } = this.props.deal;
    let currentLocation = [dealStatuses.PIPELINE, dealStatuses.REFINANCE, dealStatuses.ADDING_SUPPLEMENTAL, dealStatuses.MODIFYING];
    if (isEmpty(screenPreferenceList) || !dealsByStatus) {
      return null;
    }

    if (location.pathname.includes("dead")) {
      currentLocation = dealStatuses.DEAD;
    }

    const deals = dealsByStatus[currentLocation].data.deals;

    return (
      <Grid container spacing={24}>
        {!isEmpty(deals) &&
            Object.keys(deals).map(id => (
              <PrefTiles
                key={deals[id].id}
                deal={deals[id]}
                screenPreferences={screenPreferenceList}
                tableScreenElements={PipelineDealTileRows}
                getRows={GetDealTileRows}
              />
            ))}
      </Grid>
    );
  }
}

const mapStateToProps = ({ deal, screenPreferences }) => ({
  deal,
  screenPreferenceList: screenPreferences.screen_pref.pipeline_deal_table || null
});

export default connect(mapStateToProps, { fetchDealsStatus, getScreenPreferences })(PipelineAndDeadTiles);
